// Desc: Admin Overview page
import Layout from "../../../components/Layout";
import PageTitle from "../../../components/PageTitle";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PaymentCard from "../../../components/CardCount/PaymentCard";
import { Grid } from "@mui/material";
import { Icon } from "@iconify/react/dist/iconify.js";
import Table from "../../../components/Table/Table";
import { TableSearch } from "../../../components/Table/TableActions";
// import Badge from "../../../components/Badge";
// import PaymentOverviewData from "../../../utils/SampleData/PaymentOverview.json";
import { ItemOption, ItemStatus } from "../../../utils/DropDown";
import Modal from "../../../components/Modal";
import useStyles from "../styles";
import InputGroup from "../../../components/FormComponent/InputGroup";
import useValidator from "../../../hooks/useValidator";
import PageLoader from "../../../components/PageLoader";
import PopModal from "../../../components/PopupModal/PopModal";
import CSVExport from "../../../components/CsvExport/CsvExport";
import useWindowSize from "../../../hooks/useWindow";

const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const GET_SESSIONS = "/api/v1/school-plan/session";
const CLASSES_ENDPOINT = "/api/v1/class";
// const SCH_INTEGRATION = "/api/v1/integrations/school";
const SCH_ITEM = "/api/v1/fee-item";
const OVERVIEW_ENDPOINT = "/api/v1/invoices/student-list";
// const INVOICE_ENDOINT = "/api/v1/invoice";

const StudentList = () => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [classesData, setClassData] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  // const [value, setValue] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  // const [allInvoice, setAllInvoice] = useState([]);
  const [payemntOverview, setAllPaymentOverview] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [itemModal, setItemModal] = useState(false);
  const [itemLoading, setItemLoading] = useState(false);
  const [invoiceValidator, showInvoiceValidator] = useValidator();
  const [getIsLoading, setGetIsLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const width = useWindowSize();

  /**
 * State for managing item form data.
 * @typedef {Object} ItemFormState
 * @property {string} status - The status of the item.
 * @property {string} fee_option - The fee option for the item.
 * @property {string} item - The item name or description.
 */

  /**
 * State hook for item form management.
 * @type {[ItemFormState, Function]}
 */
  const [itemform, setItemForm] = useState({
    status: "",
    fee_option: "",
    item: ""
    // payment_method: []
  });

  /**
 * Handles changes in form inputs.
 * @function
 * @param {Object} e - The event object from the input element.
 */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemForm({ ...itemform, [name]: value });
  };

  /**
 * Toggles the item modal visibility and resets the form.
 * @function
 */
  const handleOpenItemMOdal = () => {
    setItemModal(!itemModal);
    setItemForm({ status: "", fee_option: "", item: "" });
  };

  /**
 * Determines if the current viewport is mobile sized.
 * @type {boolean}
 */
  const isMobile = width < 600;

  /**
 * Determines if the current viewport is extra small mobile sized.
 * @type {boolean}
 */
  //   const isMobile425 = width < 413;

  /**
 * Handles the creation of a new item.
 * @function
 * @description Validates the form, makes a POST request to SCH_ITEM endpoint,
 * and handles the response or error.
 */
  const handleCreateItem = () => {
    if (invoiceValidator.allValid()) {
      setItemLoading(true);
      httprequest
        .post(SCH_ITEM, itemform)
        .then((res) => {
          setItemLoading(false);
          toast.success(res?.data?.message || "Item created successfully");
          handleOpenItemMOdal();
        })
        .catch((err) => {
          setItemLoading(false);
          toast.error(err?.response?.data);
        });
    } else {
      showInvoiceValidator(true);
    }
  };

  /**
 * Fetches all terms for a specific session.
 * @function
 * @param {string} Session_ID - The ID of the session to get terms for.
 */
  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  /**
 * Fetches payment overview data for a specific term.
 * @function
 * @param {string|number} aselectedTerm - The ID of the term to get overview for.
 */
  const getOverview = (aselectedTerm) => {
    setGetIsLoading(true);
    httprequest
      .get(`${OVERVIEW_ENDPOINT}?term_id=${aselectedTerm}`)
      .then((res) => {
        setAllPaymentOverview(res?.data?.data);
        setSearchResult(res?.data?.data?.students);
        setGetIsLoading(false);
      }).catch((err) => {
        setGetIsLoading(true);
        toast.error(err?.response?.message);
      });
  };

  /**
 * Fetches all sessions from the server.
 * @async
 */
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.message);
    }
  };

  /**
 * Fetches all physical classes from the server.
 * @function
 */
  const getAllClasses = () => {
    // setIsPageFetching(true);
    httprequest
      .get(CLASSES_ENDPOINT)
      .then((res) => {
        const physicalClasses = res?.data?.data?.filter(
          (data) => data?.class_type === "physical"
        );
          // setIsPageFetching(false);
        setClassData(physicalClasses);
      })
      .catch((err) => {
        toast.error(err?.response?.data);
      });
  };

  /**
 * The active term in the current session.
 * @type {Object}
 */
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  /**
 * Handles session change events.
 * @function
 * @param {Object} e - The event object from the select input.
 */
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  /**
 * Handles term change events.
 * @function
 * @param {Object} event - The event object from the select input.
 */
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;

    setASelectedTerm(selectedTermId);
    getOverview(selectedTermId);
  };

  /**
 * Handles filter changes for student data.
 * @function
 * @param {Object} e - The event object from the select input.
 */
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter guardians based on status when the filter is applied
    const filteredByStatus = value
      ? payemntOverview?.students?.filter((data) => data?.class?.name?.toLowerCase() === value?.toLowerCase())
      : payemntOverview?.students;

    setSearchResult(filteredByStatus);
  };

  /**
 * Column definitions for the data table.
 * @type {Array<Object>}
 * @property {string} name - The column header name.
 * @property {Function} selector - Function to render cell content.
 * @property {boolean} [center] - Whether to center the column content.
 * @property {Function} [cell] - Alternative render function for cells.
 */
  const columns = [
    {
      name: "Student Name",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling"> Student Name</p>}
          {`${row?.last_name} ${row?.first_name}`}
        </>
      )
    },
    {
      name: "Class",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Class</p>}
          {row?.class?.class || "--/--"}
        </>
      )
    },
    {
      name: "Amount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Amount</p>}
          {row?.amount || 0}
        </>
      )
    },
    {
      name: "Discount",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Discount</p>}
          {row?.discount || 0}
        </>
      )
    },
    {
      name: "Expected",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Expected</p>}
          {row?.expected || 0}
        </>
      )
    },
    {
      name: "Paid",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Paid</p>}
          {row?.paid || 0}
        </>
      )
    },
    {
      name: "Outstanding",
      selector: (row) => (
        <>
          {isMobile && <p className="mobile-styling">Outstanding</p>}
          {row?.outstanding || 0}
        </>
      )
    },
    // {
    //   name: "Status",
    //   center: "true",
    //   cell: (row) => (
    //     <p style={{ display: "flex", flexDirection: "column", margin: 0, marginBlock: 0 }}>
    //       {isMobile && <p style={{ margin: 0, fontSize: "12px" }}>Status</p>}
    //       <Badge status={row?.status} />
    //     </p>
    //   )
    // },
    {
      name: "",
      selector: (row, index) => (
        <div key={index} className="table-action-container">
          {row?.status === "sent" ? (
            <>
              {isMobile && <p className="mobile-styling"></p>}
              <p className="mobile-styling">Send Receipt</p>
            </>
          ) : (null)}
          <button
            className="table-action-icon"
            onClick={() => navigate(`/payment/student-list-detail/${row?.student_id}`)}
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
        </div>
      )
    }
  ];

  /**
 * Handles student search functionality.
 * @function
 * @param {Object} e - The event object from the search input.
 */
  const handleSearchStudent = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    const filteredByStatus = filterStatus
      ? payemntOverview?.students?.filter((data) => data?.class?.name?.toLowerCase() === filterStatus.toLowerCase())
      : payemntOverview?.students;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.status
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                          data?.class?.name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                          data?.last_name
                            ?.toLowerCase()
                            .includes(word.toLowerCase()) ||
                            data?.first_name
                              ?.toLowerCase()
                              .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  /**
 * @effect
 * @description On component mount, fetches all classes, sessions, and terms.
 */
  useEffect(() => {
    getAllClasses();
    getAllSessions();
    getAllTerms();
  }, []);

  /**
 * @description When active_term_session changes, updates the selected term and fetches overview data.
 * @deps active_term_session
 */
  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session?.id);
      getOverview(active_term_session?.id);
    }
  }, [active_term_session]);

  /**
 * @effect
 * @description When activeSession changes, fetches all terms for the active session.
 */
  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  return (
    <Layout children={
      <>
        <PageTitle
          title="Student List"
          subtitle="View all student invoices"
        //   button={
        //     <div className="flex gap-10">
        //       <div className={classes.desktop}>
        //         <PopModal
        //           videoUrl="https://youtu.be/h1gorx4fILk"
        //           title="Payment Overview"
        //         />
        //       </div>
        //       <div className="flex gap-10 flex-wrap-items-413">
        //         <Button onClick={() => {
        //           navigate("/integrations");
        //         }} variant="primaryoutline" buttonSize={isMobile425 ? "full" : "fluid"} color="btnfontprimary" buttonName="Manage Payment Methods"
        //         />
        //         <Button onClick={handleOpenItemMOdal} variant="primary" buttonSize={isMobile425 ? "full" : "fluid"} color="btndefault" buttonName="Create Invoice Item" />
        //       </div>
        //     </div>
        //   }
        />
        <div className={classes.mobile}>
          <PopModal
            videoUrl="https://youtu.be/h1gorx4fILk"
            title="Payment Overview"
          />
        </div>

        <Grid container spacing={isMobile ? 1 : 3}>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <PaymentCard
              title="Total Amount"
              count={`${payemntOverview?.total_amount?.toLocaleString() || 0}`}
              icon={<Icon icon="material-symbols-light:payments-outline" />}
            />
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <PaymentCard
              title="Total Expected"
              count={`${payemntOverview?.total_expected?.toLocaleString() || 0}`}
              icon={<Icon icon="fluent:wallet-credit-card-48-filled" width="20" height="20" />}
            />
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <PaymentCard
              title="Total Discounted"
              count={`${payemntOverview?.total_discount?.toLocaleString() || 0}`}
              icon={<Icon icon="hugeicons:wallet-remove-01" width="20" height="20" />}
            />
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <PaymentCard
              title="Total Outstanding"
              count={`${payemntOverview?.total_outstanding?.toLocaleString() || 0}`}
              icon={<Icon icon="hugeicons:wallet-remove-01" width="20" height="20" />}
            />
          </Grid>
          <Grid item lg={3} md={4} sm={6} xs={12}>
            <PaymentCard
              title="Total Paid"
              count={`${payemntOverview?.total_paid || 0}`}
              icon={<Icon icon="tabler:file-invoice-filled" width="20" height="20" />}
            />
          </Grid>
        </Grid>

        <div className="flex gap-10 align-items-end margin-top-5 margin-bottom">
          <div>
            {activeSession?.id && (
              <SelectGroup
                children={
                  <select
                    defaultValue={activeSession?.id}
                    onChange={handleSessionChange}
                    name="session"
                  >
                    <option value="">---Select---</option>
                    {allSessions?.map((sesh) => {
                      return (
                        <option key={sesh?.id} value={sesh?.id}>
                          {sesh?.session}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            {active_term_session?.id && (
              <SelectGroup
                children={
                  <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                    <option value="">---Select---</option>
                    {selectedSessionTerms?.map((data) => {
                      return (
                        <option key={data?.id} value={data?.id}>
                          {data?.term}
                        </option>
                      );
                    })}
                  </select>
                }
              />
            )}
          </div>
          <div>
            <SelectGroup
              children={
                <select onChange={handleFilterChange}>
                  <option value="">---Select---</option>
                  {classesData?.map((data) => {
                    return (
                      <option key={data?.id} value={data?.class_name}>
                        {data?.class_name}
                      </option>
                    );
                  })}
                </select>
              }
            />
          </div>
        </div>

        <div className="page-content margin-top-30">
          <>
            {getIsLoading ? (
              <PageLoader />
            ) : (
              <Table
                data={searchResult}
                columns={columns}
                subHeader={true}
                pagination
                handleRowSelected={({ selectedRows }) => setSelectedRows(selectedRows.map(row => row.invoice_total))}
                subHeaderComponent={
                  <div className="action_div">
                    <TableSearch
                      placeholder="Search here..."
                      searchTableFunc={handleSearchStudent}
                    />

                    <div className="text-center gap-10 cursor-pointer">
                      <CSVExport
                        data={searchResult}
                        filename="Payment_overview_export"
                        idKey="invoice_total"
                        selectedRows={selectedRows}
                        fields={[
                          { path: "student_name", header: "Full Name" },
                          { path: "contact", header: "Phone Number" },
                          { path: "no_of_wards", header: "No of wards" },
                          { path: "is_active", header: "Active Status" }
                        ]}
                      />
                      {/* <div>
                    <SelectGroup
                      children={
                        <select name="type" onChange={handleFilterChange}>
                          <option value="">-- Item --</option>
                          <option value="active">Active</option>
                          <option value="inactive">Inactive</option>
                        </select>
                      }
                    />
                  </div> */}
                      {/* <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handleFilterChange}>
                              <option value="">-- Fee Status --</option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          }
                        />
                      </div>
                      <div>
                        <SelectGroup
                          children={
                            <select name="type" onChange={handlePaymentFilterChange}>
                              <option value="">-- Payment Method --</option>
                              <option value="active">Bank Transfer</option>
                              <option value="inactive">Payment Gateway</option>
                            </select>
                          }
                        />
                      </div> */}
                    </div>
                  </div>}
              />
            )}
          </>
        </div>
        {/* Add Option */}
        <Modal
          title="Create Invoice Item"
          subtitle={
            <div>
                Create an item to be used in your invoices.
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Item Name"
                    margin="normal"
                    inputType="text"
                    required
                    inputName="item"
                    onChange={handleChange}
                  />
                  {invoiceValidator.message("Item", itemform?.item, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Item Option"
                    required
                    children={
                      <select name="fee_option" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {ItemOption?.map((itemoptions) => {
                          return (
                            <option key={itemoptions.key} value={itemoptions?.key}>
                              {itemoptions?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {invoiceValidator.message("Item Option", itemform?.fee_option, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Status"
                    required
                    children={
                      <select name="status" onChange={handleChange}>
                        <option value="">--- Select ---</option>
                        {ItemStatus?.map((status) => {
                          return (
                            <option key={status?.key} value={status?.key}>
                              {status?.text}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {invoiceValidator.message("Status", itemform?.status, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primaryoutline"
                  buttonSize="full"
                  color="btnfontprimary"
                  buttonName="Cancel"
                  onClick={handleOpenItemMOdal}
                //   isLoading={resultCreating}
                />
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Save"
                  onClick={handleCreateItem}
                  isLoading={itemLoading}
                />
              </div>
            </>
          }
          isopen={itemModal}
          closeModal={handleOpenItemMOdal}
        />
      </>
    }
    />
  );
};

export default StudentList;
